import React from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter, Navigate } from "react-router-dom";
import {
  AfterLoginRoutes,
  ProtectedRouters,
  approvalRoutes,
  publicRoutes,
} from "./router";

export const RouterContext = createContext()

export const RoutersProvider = ({ children }) => {

const { token,currentUser } = useSelector((state) => state.store);
let roleId;
let permissions;
// console.log("RouterContext: ", currentUser?.data?.permissions);
if (currentUser?.data?.user) {
  roleId = currentUser?.data?.user?.user_role?.role_id;
  permissions = currentUser?.data?.permissions;
  // console.log("permissions`", permissions);
}

const roleSixAllowedPaths = new Set([
  "dashboard",
  ...approvalRoutes.map((route) => route.path),
]);

const attachPermissionsMeta = (route, routePermissions = []) => ({
  ...route,
  element: React.isValidElement(route.element)
    ? React.cloneElement(route.element, {
        ...route.element.props,
        meta: routePermissions,
      })
    : route.element,
});

const roleBasedRouter = (routes) => {
  if (roleId === 1) return routes;
  if (roleId === 6) {
    return routes
      ?.filter((route) => roleSixAllowedPaths.has(route.path))
      .map((route) => attachPermissionsMeta(route));
  }

  if (routes) {
    return routes.reduce((acc, route) => {
      const routePermission = permissions?.find(
        (permission) =>
          permission?.component?.name === route?.meta?.name &&
          permission?.permissions?.some(
            (item) => item.permissionName === "Read"
          )
      );

      if (routePermission) {
        acc.push(attachPermissionsMeta(route, [routePermission]));
      }

      return acc;
    }, []);
  }

  return routes;
};

const fileteredRotues=roleBasedRouter(AfterLoginRoutes);
const defaultRoute=fileteredRotues?.[0]?.path
ProtectedRouters.children=defaultRoute?[
  {
    index:true,
    element:<Navigate to={defaultRoute} replace />,
  },
  ...fileteredRotues,
  {
    path:"*",
    element:<Navigate to={defaultRoute} replace />,
  },
]:[
  {
    index:true,
    element:<div>No accessible routes found for this role.</div>,
  },
  {
    path:"*",
    element:<div>No accessible routes found for this role.</div>,
  },
]

const router = createBrowserRouter([...publicRoutes,ProtectedRouters]);
   
    // Action jaisa hai @end
    return (
        <RouterContext.Provider
            value={{
                // Router
                router,  
                fileteredRotues              
            }}
        >
            {children}
        </RouterContext.Provider>
    )
}


export default RouterContext
